// frontend/src/pages/historias/ProgresoFormulario.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  LinearProgress,
  Chip,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, 
  Alert,
  Tabs,
  Tab,
  
} from '@mui/material';

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot
} from '@mui/lab';

import {
  ArrowBack,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Remove as RemoveIcon,
  PictureAsPdf as PdfIcon,
  Timeline as TimelineIcon,
  BarChart as ChartIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { Line, Bar, Doughnut } from 'react-chartjs-2';
import formularioService from '../../services/formularioService';
import PageHeader from '../../components/common/PageHeader';
import Loader from '../../components/common/Loader';

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const ProgresoFormulario = () => {
  const { parentRespuestaId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [formularioPadre, setFormularioPadre] = useState(null);
  const [analisisProgreso, setAnalisisProgreso] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    cargarDatos();
  }, [parentRespuestaId]);
  
  const cargarDatos = async () => {
    try {
      setLoading(true);
      
      // Cargar formulario padre
      const respuestaPadre = await formularioService.getRespuesta(parentRespuestaId);
      setFormularioPadre(respuestaPadre);
      
      // Cargar análisis de progreso
      const analisis = await formularioService.getAnalisisProgreso(parentRespuestaId);
      if (analisis.success) {
        setAnalisisProgreso(analisis.data);
      }
      
    } catch (error) {
      console.error('Error al cargar datos:', error);
      setError('Error al cargar el análisis de progreso');
    } finally {
      setLoading(false);
    }
  };
  
  const handleGenerarReporte = async () => {
    try {
      // Aquí iría la lógica para generar un PDF del reporte
     } catch (error) {
      console.error('Error al generar reporte:', error);
    }
  };
  
  const prepararDatosGrafico = () => {
    if (!analisisProgreso || analisisProgreso.tipo_seguimiento !== 'cuantitativo') {
      return null;
    }
    
    const labels = [];
    const datosPromedio = [];
    const datosLogrados = [];
    const datosEnProceso = [];
    
    analisisProgreso.evaluaciones_por_mes?.forEach(mes => {
      labels.push(mes.mes);
      datosPromedio.push(mes.promedio_general);
      
      let logrados = 0;
      let enProceso = 0;
      
      mes.objetivos.forEach(obj => {
        if (obj.estado === 'logrado') logrados++;
        else if (obj.estado === 'en_proceso') enProceso++;
      });
      
      datosLogrados.push(logrados);
      datosEnProceso.push(enProceso);
    });
    
    return {
      labels,
      datasets: [
        {
          label: 'Promedio General',
          data: datosPromedio,
          borderColor: 'rgb(75, 192, 192)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          yAxisID: 'y',
        },
        {
          label: 'Objetivos Logrados',
          data: datosLogrados,
          backgroundColor: 'rgba(75, 192, 75, 0.5)',
          type: 'bar',
          yAxisID: 'y1',
        },
        {
          label: 'En Proceso',
          data: datosEnProceso,
          backgroundColor: 'rgba(255, 206, 86, 0.5)',
          type: 'bar',
          yAxisID: 'y1',
        }
      ]
    };
  };
  
  const prepararDatosDonut = () => {
    if (!analisisProgreso) return null;
    
    const resumen = analisisProgreso.resumen || analisisProgreso.resumen_general || {};
    
    return {
      labels: ['Logrados', 'En Proceso', 'Reprogramación'],
      datasets: [{
        data: [
          resumen.logrados || resumen.objetivos_logrados || 0,
          resumen.en_proceso || resumen.objetivos_en_proceso || 0,
          resumen.reprogramacion || 0
        ],
        backgroundColor: [
          'rgba(75, 192, 75, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(255, 99, 132, 0.8)'
        ],
        borderWidth: 1
      }]
    };
  };
  
  const getIconoTendencia = (tendencia) => {
    switch (tendencia) {
      case 'mejorando': return <TrendingUpIcon color="success" />;
      case 'empeorando': return <TrendingDownIcon color="error" />;
      default: return <RemoveIcon color="action" />;
    }
  };
  
  const renderTabGeneral = () => (
    <Grid container spacing={3}>
      {/* Tarjetas de resumen */}
      <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Total Sesiones
            </Typography>
            <Typography variant="h4">
              {analisisProgreso?.total_sesiones || 0}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Objetivos Trabajados
            </Typography>
            <Typography variant="h4">
              {analisisProgreso?.objetivos_trabajados || 
               analisisProgreso?.objetivos_evaluados_total || 0}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Porcentaje de Logro
            </Typography>
            <Typography variant="h4" color="success.main">
              {analisisProgreso?.porcentaje_logro || 0}%
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={3}>
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Estado General
            </Typography>
            <Chip 
              label={
                analisisProgreso?.porcentaje_logro >= 70 ? 'Excelente' :
                analisisProgreso?.porcentaje_logro >= 50 ? 'Bueno' :
                analisisProgreso?.porcentaje_logro >= 30 ? 'Regular' : 'Inicial'
              }
              color={
                analisisProgreso?.porcentaje_logro >= 70 ? 'success' :
                analisisProgreso?.porcentaje_logro >= 50 ? 'primary' :
                analisisProgreso?.porcentaje_logro >= 30 ? 'warning' : 'default'
              }
              size="medium"
            />
          </CardContent>
        </Card>
      </Grid>
      
      {/* Gráfico de distribución */}
      {prepararDatosDonut() && (
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Distribución de Objetivos
            </Typography>
            <Box sx={{ height: 300 }}>
              <Doughnut 
                data={prepararDatosDonut()} 
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      position: 'bottom'
                    }
                  }
                }}
              />
            </Box>
          </Paper>
        </Grid>
      )}
      
      {/* Lista de objetivos más recientes */}
      <Grid item xs={12} md={6}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Últimas Evaluaciones
          </Typography>
          {analisisProgreso?.detalle_objetivos?.slice(0, 5).map((obj, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="body2">
                  Objetivo {obj.objetivo_id}
                </Typography>
                <Chip 
                  size="small"
                  label={obj.ultimo_estado}
                  color={
                    obj.ultimo_estado === 'logrado' ? 'success' :
                    obj.ultimo_estado === 'en_proceso' ? 'warning' : 'error'
                  }
                />
              </Box>
              <LinearProgress 
                variant="determinate" 
                value={obj.total_sesiones * 20} 
                sx={{ mt: 1 }}
              />
            </Box>
          ))}
        </Paper>
      </Grid>
    </Grid>
  );
  
  const renderTabDetalle = () => {
    if (analisisProgreso?.tipo_seguimiento === 'cualitativo') {
      return (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Objetivo</TableCell>
                <TableCell align="center">Sesiones</TableCell>
                <TableCell align="center">Último Estado</TableCell>
                <TableCell align="center">Progreso</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {analisisProgreso?.detalle_objetivos?.map((obj, index) => (
                <TableRow key={index}>
                  <TableCell>{obj.objetivo_id}</TableCell>
                  <TableCell align="center">{obj.total_sesiones}</TableCell>
                  <TableCell align="center">
                    <Chip 
                      size="small"
                      label={obj.ultimo_estado}
                      color={obj.ultimo_estado === 'logrado' ? 'success' : 'warning'}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <LinearProgress 
                      variant="determinate" 
                      value={obj.ultimo_estado === 'logrado' ? 100 : 50} 
                      sx={{ width: 100, mx: 'auto' }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
    
    // Para seguimiento cuantitativo
    return (
      <Box>
        {prepararDatosGrafico() && (
          <Paper sx={{ p: 2, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
              Evolución Mensual
            </Typography>
            <Box sx={{ height: 400 }}>
              <Line 
                data={prepararDatosGrafico()} 
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  interaction: {
                    mode: 'index',
                    intersect: false,
                  },
                  scales: {
                    y: {
                      type: 'linear',
                      display: true,
                      position: 'left',
                      min: 0,
                      max: 3.5,
                      title: {
                        display: true,
                        text: 'Promedio'
                      }
                    },
                    y1: {
                      type: 'linear',
                      display: true,
                      position: 'right',
                      grid: {
                        drawOnChartArea: false,
                      },
                      title: {
                        display: true,
                        text: 'Cantidad de Objetivos'
                      }
                    },
                  },
                }}
              />
            </Box>
          </Paper>
        )}
        
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Objetivo</TableCell>
                <TableCell align="center">Evaluaciones</TableCell>
                <TableCell align="center">Promedio Global</TableCell>
                <TableCell align="center">Último Estado</TableCell>
                <TableCell align="center">Tendencia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(analisisProgreso?.estadisticas_por_objetivo || {}).map(([objId, stats]) => (
                <TableRow key={objId}>
                  <TableCell>{objId}</TableCell>
                  <TableCell align="center">{stats.evaluaciones}</TableCell>
                  <TableCell align="center">
                    <Typography 
                      color={
                        stats.promedio_global >= 3 ? 'success.main' :
                        stats.promedio_global >= 2 ? 'warning.main' : 'error.main'
                      }
                      fontWeight="bold"
                    >
                      {parseFloat(stats.promedio_global).toFixed(2)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      size="small"
                      label={stats.ultimo_estado}
                      color={
                        stats.ultimo_estado === 'logrado' ? 'success' :
                        stats.ultimo_estado === 'en_proceso' ? 'warning' : 'error'
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    {getIconoTendencia(stats.tendencia)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };
  
  const renderTabTimeline = () => (
    <Timeline position="alternate">
      {analisisProgreso?.detalle_objetivos?.map((obj, index) => (
        obj.historial?.map((sesion, sesionIndex) => (
          <TimelineItem key={`${index}-${sesionIndex}`}>
            <TimelineSeparator>
              <TimelineDot 
                color={
                  sesion.estado === 'logrado' ? 'success' :
                  sesion.estado === 'en_proceso' ? 'warning' : 'grey'
                }
              >
                {sesion.estado === 'logrado' ? <CheckCircleIcon /> : <WarningIcon />}
              </TimelineDot>
              {sesionIndex < obj.historial.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="h6" component="h1">
                  {obj.objetivo_id}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {new Date(sesion.fecha).toLocaleDateString()}
                </Typography>
                <Chip 
                  size="small" 
                  label={sesion.estado}
                  color={sesion.estado === 'logrado' ? 'success' : 'warning'}
                  sx={{ mt: 1 }}
                />
                {sesion.actividades && (
                  <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                    Actividades: {sesion.actividades.substring(0, 100)}...
                  </Typography>
                )}
              </Paper>
            </TimelineContent>
          </TimelineItem>
        ))
      ))}
    </Timeline>
  );
  
  if (loading) {
    return <Loader />;
  }
  
  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">{error}</Alert>
        <Button 
          variant="contained" 
          onClick={() => navigate(-1)}
          sx={{ mt: 2 }}
        >
          Volver
        </Button>
      </Box>
    );
  }
  
  return (
    <Box>
      <PageHeader 
        title="Análisis de Progreso Terapéutico"
        subtitle={formularioPadre?.formulario?.nombre}
        icon={<AssessmentIcon />}
      />
      
      <Box p={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
          >
            Volver
          </Button>
          
          <Button
            variant="contained"
            startIcon={<PdfIcon />}
            onClick={handleGenerarReporte}
          >
            Generar Reporte PDF
          </Button>
        </Box>
        
        {/* Información del plan */}
        <Paper sx={{ p: 2, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="textSecondary">
                Plan Terapéutico
              </Typography>
              <Typography variant="body1">
                {formularioPadre?.formulario?.nombre}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="textSecondary">
                Fecha de Inicio
              </Typography>
              <Typography variant="body1">
                {new Date(formularioPadre?.fecha_completado).toLocaleDateString()}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="caption" color="textSecondary">
                Tipo de Seguimiento
              </Typography>
              <Typography variant="body1" textTransform="capitalize">
                {analisisProgreso?.tipo_seguimiento?.replace('_', ' ')}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
        
        {/* Tabs de contenido */}
        <Paper sx={{ mb: 3 }}>
          <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
            <Tab label="Resumen General" />
            <Tab label="Detalle por Objetivo" />
            <Tab label="Línea de Tiempo" />
          </Tabs>
        </Paper>
        
        {/* Contenido según tab */}
        <Box role="tabpanel" hidden={tabValue !== 0}>
          {renderTabGeneral()}
        </Box>
        
        <Box role="tabpanel" hidden={tabValue !== 1}>
          {renderTabDetalle()}
        </Box>
        
        <Box role="tabpanel" hidden={tabValue !== 2}>
          {renderTabTimeline()}
        </Box>
      </Box>
    </Box>
  );
};

export default ProgresoFormulario;